{
  "version": 1,
  "asset_id": "2ae9178b-42f7-4b60-8170-d210bb55f234",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/2ae9178b-42f7-4b60-8170-d210bb55f234/egg-common.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/2ae9178b-42f7-4b60-8170-d210bb55f234/egg-common.webp",
  "original_filename": "egg-common.webp",
  "size": 5448,
  "content_type": "image/webp",
  "created_at": "2026-08-06T21:53:52Z"
}
